import SectionBanner from "../sections/somos/SectionBanner";
import SectionAboutUs from "../sections/somos/SectionAboutUs";
import SectionHistory from "../sections/somos/SectionHistory";
import SectionInfo from "../sections/somos/SectionInfo";

const Somos = () => {
  return (
    <>
      <SectionBanner />
      <SectionAboutUs />
      <SectionHistory />
      <SectionInfo />
    </>
  );
};

export default Somos;
